import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import querystring from 'query-string';
import labelRequest from '../labelRequest';

export default function getAllWishlists(wishlistConfigs) {
    const { baseUrl, brandId, country, uberToken, clientId, clientSecret, getAllWishlistsOptions: options } = wishlistConfigs;

    invariant(baseUrl, 'baseUrl is a required param of getAllWishlists()');
    invariant(brandId, 'brandId is a required param of getAllWishlists()');
    invariant(country, 'country is a required param of getAllWishlists()');
    invariant(uberToken, 'uberToken is a required param of getAllWishlists()');
    invariant(clientId, 'clientId is a required param of getAllWishlists()');

    const headers = { 'Content-Type': 'application/json' };

    const optionalQuery = options && Object.keys(options).length > 0 ? `&${querystring.stringify(options)}` : '';
    const fetchUrl = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/wishlist/@self?profileName=IBM_Store_Summary${optionalQuery}`;

    return labelRequest(
        authenticatedRequest(new Request(fetchUrl, { headers: new Headers(headers), method: 'GET' }), uberToken, clientId, clientSecret),
        'getAllWishlists',
    );
}
